/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SuperuserPoolAdminService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Pool admin settings for a company (superuser only)
   * @param companyUuid UUID of the company
   * @returns any Pool admin settings retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesSuperuserPool(
    companyUuid: string,
  ): CancelablePromise<{
    data?: {
      companyUuid?: string;
      freemiumProducts?: {
        pool?: {
          enabled?: boolean;
        };
      };
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/superuser/pool/{companyUuid}',
      path: {
        'companyUuid': companyUuid,
      },
      errors: {
        403: `Forbidden - superuser role required`,
        404: `Company not found`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Toggle product freemium for a company (superuser only)
   * @param requestBody
   * @returns any Freemium setting updated successfully
   * @throws ApiError
   */
  public patchApiServiceorganizationsProcessesSuperuserFreemium(
    requestBody: {
      /**
       * UUID of the company to update
       */
      companyUuid: string;
      /**
       * The product to toggle freemium access for
       */
      product: 'pool';
      /**
       * Set to true to enable freemium access for this product
       */
      enabled: boolean;
    },
  ): CancelablePromise<{
    data?: {
      companyUuid?: string;
      product?: 'pool';
      enabled?: boolean;
    };
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/processes/superuser/freemium',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - validation error`,
        403: `Forbidden - superuser role required`,
        404: `Company not found`,
        500: `Internal server error`,
      },
    });
  }

}
